import { render, staticRenderFns } from "./WxBindDialog.vue?vue&type=template&id=7517eaa3&scoped=true"
import script from "./WxBindDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WxBindDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WxBindDialog.vue?vue&type=style&index=0&id=7517eaa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517eaa3",
  null
  
)

export default component.exports